module.exports = __webpack_public_path__ + "static/img/jianzhi2.6df91ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-parttime/jianzhi2.png
// module id = g+pu
// module chunks = 1